import React from 'react';
import { compose } from 'ramda';
import styleFile from './ModalOnSelectRate.js';
import { FIDELTOUR_CODE } from '@synergycms_app/store/customer/loyaltyActions';
import { connect } from 'react-redux';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import Modal from '@synergycms_core/components/generic/Modal';
import { Button, RichText, Image } from '@synergycms_core/components/generic';



const ModalOnUnSelectCheck = props => {
  const { children, theme } = props;
  const { classes } = theme.styles;
  const { closeCallback, type} = props.config;


  return (
    <Modal
      innerStyle={[theme.computedInnerStyle, classes.modalStyle].join(' ')}
      contentStyle={classes.contentSTModal}
      closeButtonStyle={[classes.closeBtnStModal, type === FIDELTOUR_CODE ? classes.closeBtnFt : '']}
      modalStyle={classes.noDispoModal}
      refreshOnMount={true}
      typeModal={'roomDetailTooltip'}
      popover={(closeModal)=>
        (<div className={[classes.modalTabsList, classes.modalStContainer].join(' ')}>
          <div className={classes.headerModal}>

            <div className={[classes.starLogo,classes.memberOnlyBlue].join(' ')}>
              <Image svg={'memberOnlyBlue'}/>
            </div>
            <RichText
              innerStyle={[classes.modalTitle, classes.ftTitle]}
              text={'_%¿estás seguro de que no quieres registrarte en nuestro programa members only%_'}
              translate={true}
              ucFirst={false}
            />
            <RichText
              innerStyle={classes.modalSubTitle}
              text={'_%Te perderás los <b>descuentos exclusivos</b> asociados a nuestro programa de <b>Fidelización</b>.%_'}
              translate={true}
              ucFirst={false}
              dangerouslySetInnerHTML={true}
            />

            <div className={classes.btnsContainer}>
              <Button innerStyle={[classes.upercase, classes.ftBtnInterest, classes.buttonInterest]} onClick={()=>{ closeCallback(true); closeModal() }}>
                <RichText
                  text={'_%quiero registrarme%_'}
                  translate={true}
                  ucFirst={false}
                />
              </Button>
              <Button innerStyle={[classes.ButtonNoInterest, classes.ftNoInterest]} onClick={()=>{closeCallback(false); closeModal()}}>
                <RichText
                  text={'_%no, gracias (Tu consulta se actualizará al precio general)%_'}
                  translate={true}
                  ucFirst={true}
                />
              </Button>
            </div>

          </div>
        </div>)
      }>
      {children}
    </Modal>
  );

};
const mapStateToProps = (store) => {
  
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  return {
    loyalty,
    type: loyalty && loyalty.get("code"),
  }
};
  


export default compose(
  connect(mapStateToProps),
  PropertyManager([ 'closeCallback','children',"type"]),
  withThemeJSS({ styleFile, link: true, displayName: 'LoyaltySureModal' })
)(ModalOnUnSelectCheck);
